module.exports = __webpack_public_path__ + "img/img(3).424f156b.png";